import { formatDiff } from "../utils/scoring";

interface DiffBadgeProps {
	className?: string;
	diff: number | null;
	placeholder?: string;
}

export const DiffBadge: React.FC<DiffBadgeProps> = ({ diff, placeholder = "--", className = "" }) => {
	const diffStr = formatDiff(diff);
	if (!diffStr) {
		return <span className={`text-gray-300 ${className}`}>{placeholder}</span>;
	}
	return (
		<span className={`${diff! > 0 ? "text-green-600" : "text-red-600"} ${className}`}>
			{diffStr}
		</span>
	);
};
